
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesLaborGrid extends Serenity.EntityGrid<POSSalesLaborRow, any> {
        protected getColumnsKey() { return 'Retail.POSSalesLabor'; }
        protected getIdProperty() { return POSSalesLaborRow.idProperty; }
        protected getInsertPermission() { return POSSalesLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesLaborRow.localTextPrefix; }
        protected getService() { return POSSalesLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}